import { PropTypes } from 'prop-types';
import { CONTENT_TYPES } from '~/constants';
import { contentType as ct } from '~/types';

import { PostPreviewCard } from '../SelectPostsModal/PostPreviewCard';
import { ReelPreviewCard } from '../SelectReelsModal';
import { StoryPreviewCard } from '../SelectStoriesModal';
import { TiktokPreviewCard } from '../SelectTiktokModal';
import { YoutubePreviewCard } from '../SelectYoutubeModal';

const propTypes = {
  content: ct,
  contentType: PropTypes.oneOf(Object.keys(CONTENT_TYPES)),
};

const PREVIEW_CARD_COMPONENTS = {
  [CONTENT_TYPES.post]: PostPreviewCard,
  [CONTENT_TYPES.story]: StoryPreviewCard,
  [CONTENT_TYPES.reels]: ReelPreviewCard,
  [CONTENT_TYPES.tiktok]: TiktokPreviewCard,
  [CONTENT_TYPES.youtube]: YoutubePreviewCard,
};

export const PreviewCard = ({ content, contentType }) => {
  const PreviewCardComponent = PREVIEW_CARD_COMPONENTS[contentType];

  return <PreviewCardComponent content={content} />;
};

PreviewCard.propTypes = propTypes;
